import React from 'react';

import { TitleDivider } from '../title-divider';
import { HalfHalfSection } from '../half-half-section';
import { Title } from '../title';
import { ArrowLink } from '../arrow-link';
import { Textfield } from '../textfield';
import { Button } from '../button';
import { RichText } from '../rich-text';

export class Newsletter extends React.Component {
  constructor (props) {
    super(props);
    this.state = { open: false };
  }

  openForm = () => { this.setState({ open: true }); }

  submit = () => { this.refs.form.submit(); }

  render () {
    return (
      <section className="newsletter">
        <a name="newsletter" id="newsletter" />
        <TitleDivider>{ this.props.eyebrow }</TitleDivider>
        <HalfHalfSection>
          <div><Title content={ this.props.title } /></div>
          <div className="typo-body">
            <p>{ this.props.intro }</p>

            { !this.state.open && <ArrowLink onClick={this.openForm}>{ this.props.button }</ArrowLink> }

            { this.state.open && (
              <div className="newsletter__form">
                <form action="//www.flexmail.eu/subscribe" method="post" target="iframe_flxml_submit" ref="form">
                  <input type="hidden" id="public-key" name="public-key" value={this.props.apiKey} />
                  <input type="hidden" id="language" name="fields[6f18346f0dfa06863741529fd716f08d]" value={this.props.language} />

                  <Textfield label={ this.props.firstname } name="fields[117979cc352353c57a691a947b04167f]" />
                  <Textfield label={ this.props.lastname } name="fields[1a2f3e3b4cebe60c0e9659520e7e121a]" />
                  <Textfield label={ this.props.email } name="fields[2426ced136024a631a2a0672a269b700]" />
                  <Button onClick={ this.submit }>{ this.props.submit }</Button>
                  <div className="newsletter__message">
                    <RichText document={this.props.notes} />
                  </div>
                </form>
                <iframe id="iframe_flxml_submit" name="iframe_flxml_submit" width="100%" height="50" src="//www.flexmail.eu/public/blank.html" frameborder="0" scrolling="no" />
              </div>
            )}
          </div>
        </HalfHalfSection>
      </section>
    );
  }
}